var Operator = window.Operator || {};
Operator.blockEditors = Operator.blockEditors || {};

$.extend(Operator.blockEditors, {
    ArrayUnionBrickModel: function (opts) {
        var block = opts.block
            , editor = opts.editor
            , form = editor.find('form');

        Operator.Layout.setupCollections(form);

        form.on('submit', function (e) {
            Operator.blockEditors._generatePortsOnFormSubmit(e, editor, block, 'input', '.input-port-mapping-port');
        });
    }
});